<template>
    <v-container>

        <v-card color="primary" dark>
            <v-card-title>
                    <span style="font-weight: bold">
                        บุคลากรตามตำแหน่งวิชาการ
                    </span>
            </v-card-title>
        </v-card>
        <v-card color="#546E7A" dark>
            <v-card-text>
                <v-list-item>
                    <v-row class="d-flex justify-center">
                        <v-col
                                cols="12"
                                md="10">
                            <v-expansion-panels >
                                <v-expansion-panel
                                        v-for="(item,i) in ReportData"
                                        :key="i"
                                >
                                    <v-expansion-panel-header color="#CFD8DC">
                                        <span style="font-weight: bold;color:black;">
                                            {{item.PosName}}
                                        </span>
                                        <v-spacer></v-spacer>
                                        <div align="right">
                                            <v-chip color="#B71C1C" dark>
                                                {{item.count}}
                                            </v-chip>
                                        </div>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content color="#CFD8DC">
                                        <v-card color="#546E7A" dark>
                                            <v-card-title>
                                                <span style="font-weight: bold">
                                                    หน่วยงาน
                                                </span>
                                                <v-spacer></v-spacer>
                                                <v-text-field
                                                        v-model="search"
                                                        append-icon="mdi-magnify"
                                                        label="ค้นหา"
                                                        single-line
                                                        hide-details
                                                ></v-text-field>
                                            </v-card-title>
                                            <v-card-text>
                                                <v-data-table
                                                        :headers="headerData"
                                                        :items="item.DepData"
                                                        :search="search"
                                                        :items-per-page="5"
                                                        class="elevation-1"
                                                >
                                                    <template v-slot:item.count="{item}">
                                                        <span>
                                                             {{item.StaffData.length}} คน
                                                        </span>
                                                    </template>
                                                    <template v-slot:item.action="{item}">
                                                        <v-btn outlined color="#00BCD4" @click="ShowDetail(item)">
                                                            แสดงข้อมูล
                                                        </v-btn>
                                                    </template>
                                                </v-data-table>
                                            </v-card-text>
                                        </v-card>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-col>
                    </v-row>
                </v-list-item>
            </v-card-text>
        </v-card>
        <template>
            <v-dialog
                    v-model="dialog"
                    max-width="1000"
            >
                <v-card color="#546E7A" dark>
                    <v-card-title class="headline">
                        หน่วยงาน : {{PosName}}
                        <v-spacer></v-spacer>
                        <v-text-field
                                v-model="search2"
                                append-icon="mdi-magnify"
                                label="ค้นหา ฃื่อ - สกุล"
                                single-line
                                hide-details
                        ></v-text-field>
                    </v-card-title>

                    <v-card-text>
                        <v-data-table
                                :headers="headerData2"
                                :items="DataToShow"
                                :search="search2"
                                :items-per-page="5"
                                class="elevation-1"
                        >
                            <template v-slot:item.full_Name="{item}">
                                <span>
                                     {{item.full_Name}} ({{item.perid}})
                                </span>
                            </template>
                            <template v-slot:item.LevelName="{item}">
                                  <span v-if="item.LevelCode == '5' || item.LevelCode == '6'" style="font-weight: bold;color: cornflowerblue">
                                            {{item.LevelName}}
                                        </span>
                                <span v-else-if="item.LevelCode == '8' || item.LevelCode == '9'" style="font-weight: bold;color: cadetblue">
                                            {{item.LevelName}}
                                        </span>
                                <span v-else>
                                     {{item.LevelName}}
                                </span>
                            </template>
                        </v-data-table>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>

                        <v-btn
                                color="green darken-1"
                                text
                                @click="dialog = false"
                        >
                            ปิดหน้าต่าง
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>
    </v-container>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: "AcademicPosition",
        data() {
            return {
                search: '',
                search2: '',
                dialog: false,
                isMobile: false,
                ReportData: [],
                DataToShow: {},
                PosName: '',
                headerData: [
                    {text: 'หน่วยงาน', value: 'dep_name'},
                    {text: 'กลุ่มหน่วยงาน', value: 'dep_group_name'},
                    {text: 'จำนวน', value: 'count'},
                    {text: '', value: 'action'},
                ],
                headerData2: [
                    {text: 'ชื่อ-สกุล', value: 'full_Name'},
                    {text: 'หน่วยงาน', value: 'dep_name'},
                    {text: 'ตำแหน่ง', value: 'pos_name'},
                ],
            }
        },
        beforeDestroy() {
            if (typeof window !== 'undefined') {
                window.removeEventListener('resize', this.onResize, {passive: true})
            }
        },
        computed: {
            ...mapGetters({
                MeData: 'Staff/getMeData',
                levelData: 'Level/getLevel',
                DepartData: 'Depart/getDepart',
                PositionsData: 'Positions/getPosition',
                staffData: 'Staff/getStaff',
            })
        },
        methods: {
            ...mapActions({
                initMeData: 'Staff/initMeData',
                initlevelData: 'Level/initLevelData',
                initDepartData: 'Depart/initDepartData',
                initPositionData: 'Positions/initPositionData',
                initStaffData: 'Staff/initStaffData',
            }),
            onResize() {
                this.isMobile = window.innerWidth < 600
            },
            goToPage: function (page) {
                this.$router.push(page)
            },
            ShowDetail(item) {
                this.dialog = true
                this.DataToShow = {}
                this.PosName = ''
                this.PosName = item.dep_name
                this.DataToShow = item.StaffData
            }
        },
        mounted() {
            this.onResize()
            window.addEventListener('resize', this.onResize, {passive: true})
            this.initPositionData()
            this.initDepartData()
            this.initStaffData().then(res => {
                if (res) {
                    this.PositionsData.map(posi_i => {
                        var count = 1
                        if(posi_i.PosCode >= 'C53' && posi_i.PosCode <= 'C60') {
                            this.staffData.map(staff_i => {
                                if (posi_i.PosCode == staff_i.pos_id) {
                                    this.DepartData.map((Dep_i) => {
                                        if(Dep_i.dep_id == staff_i.dep_id) {
                                            if (this.ReportData.length == 0) {
                                                this.ReportData.push({
                                                    ...posi_i,
                                                    percent: 0,
                                                    count: count++,
                                                    DepData: [{
                                                        ...Dep_i,
                                                        StaffData: [{
                                                            ...staff_i
                                                        }]
                                                    }]
                                                })
                                            } else {
                                                var CheckCordi = false
                                                this.ReportData.map((report_i, idx) => {
                                                    if (report_i.PosCode == posi_i.PosCode) {
                                                        CheckCordi = true
                                                        var CheckCordi2 = false
                                                        report_i.DepData.map((report_dep_i, r_d_i_idx) => {
                                                            if(report_dep_i.dep_id == Dep_i.dep_id) {
                                                                CheckCordi2 = true
                                                                this.ReportData[idx].count = count++
                                                                this.ReportData[idx].DepData[r_d_i_idx].StaffData.push({
                                                                    ...staff_i
                                                                })
                                                            } else {
                                                                if (!CheckCordi2 && r_d_i_idx == report_i.DepData.length - 1) {
                                                                    this.ReportData[idx].count = count++
                                                                    this.ReportData[idx].DepData.push({
                                                                        ...Dep_i,
                                                                        StaffData: [{
                                                                            ...staff_i
                                                                        }]
                                                                    })
                                                                }
                                                            }
                                                        })
                                                    } else {
                                                        if (!CheckCordi && idx == this.ReportData.length - 1) {
                                                            this.ReportData.push({
                                                                ...posi_i,
                                                                percent: 0,
                                                                count: count++,
                                                                DepData: [{
                                                                    ...Dep_i,
                                                                    StaffData: [{
                                                                        ...staff_i
                                                                    }]
                                                                }]
                                                            })
                                                        }
                                                    }
                                                })
                                            }
                                        }
                                    })

                                }
                            })
                        }
                    })
                }
            })
        }

    }
</script>

<style scoped>

</style>